import React, { useState } from 'react';
import './Portfolio.css';

function Portfolio() {
  const [filter, setFilter] = useState('all');

  const projects = [
    {
      id: 1,
      title: 'Pele Chaharom',
      category: 'architecture',
      description: '"Pele Chaharom" is a proposed community center located near Tehran\'s historic Vali-e-Asr Street. The project aims to revitalize an underutilized urban passage into a vibrant social hub by integrating diverse functional spaces such as galleries, cafes, restaurants, and co-working offices. Inspired by the geometric form of steps, the architectural design features a series of interconnected terraces that facilitate social interaction and enhance the quality of urban life, transforming a mere transit route into a dynamic place for dialogue and collective experience.',
      year: '1403',
      image: '/PeleChaharom.png'
    },
    {
      id: 2,
      title: 'Green House',
      category: 'architecture',
      description: '"Green House" is a 100-unit residential complex in Tehran\'s Tavanir neighborhood, designed to harmonize with nature. The project features integrated green surfaces, curved architectural forms, and wood accents to create a serene, sustainable environment. By incorporating public spaces like cafes and shops alongside safe pedestrian paths and diverse green areas, the design transforms the entrance into an active social hub that fosters family interaction and child-friendly play.',
      year: '1403',
      image: '/GreenHouse.jpg'
    },
    {
      id: 3,
      title: 'Jaryan Community Center',
      category: 'architecture',
      description: '"Jaryan Community Center" is a social and cultural hub located on Tehran\'s Vozara Street, designed to connect people with the city. Positioned along a key urban path linking Abbas Abad to Vali-e-Asr, it uses creative ramps and bridges to overcome site elevation challenges, turning them into a fluid journey for pedestrians and cyclists. The project bridges a quiet residential zone with a bustling commercial street, offering spaces like a library and learning areas for both local residents and passersby.',
      year: '1402',
      image: '/JaryanCommunityCenter.jpg'
    },
    {
      id: 4,
      title: 'The Two-Faced House',
      category: 'architecture',
      description: '"The Two-Faced House" is a dual-purpose villa that integrates a family residence with an architect\'s studio. Using a structural core of two perpendicular walls, the design creates a balanced transition between public work areas and private living spaces, ensuring privacy while maintaining a cohesive architectural flow.',
      year: '1401',
      image: '/TheTwo-FacedHouse.jpg'
    },
    {
      id: 5,
      title: 'Niqab: Iran Performing Arts Center',
      category: 'architecture',
      description: 'Inspired by the "masking" essence of theater, this project uses layered shells to create a sense of mystery. It features a central courtyard and panoramic views, blending urban interaction with a symbolic journey into the performing arts.',
      year: '1402',
      image: '/Niqab.jpg'
    }
  ];

  const filteredProjects = filter === 'all' 
    ? projects 
    : projects.filter(project => project.category === filter);

  return (
    <section id="portfolio" className="portfolio">
      <div className="container">
        <h2 className="section-title">Portfolio</h2>
        <p className="section-subtitle">Selected Works</p>
        <div className="divider"></div>
        
        <div className="filter-buttons">
          <button 
            className={filter === 'all' ? 'active' : ''}
            onClick={() => setFilter('all')}
          >
            All
          </button>
          <button 
            className={filter === 'architecture' ? 'active' : ''}
            onClick={() => setFilter('architecture')}
          >
            Architecture
          </button>
          <button 
            className={filter === 'interior' ? 'active' : ''}
            onClick={() => setFilter('interior')}
          >
            Interior Design
          </button>
        </div>

        <div className="projects-grid">
          {filteredProjects.map((project, index) => (
            <div 
              key={project.id} 
              className="project-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="project-image-container">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="project-image"
                />
              </div>
              <div className="project-info">
                <div className="project-meta">
                  <span className="project-category">{project.category}</span>
                  <span className="project-year">{project.year}</span>
                </div>
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Portfolio;

